export class DisclaimerDTO {
  constructor(readonly link: string, readonly disclaimer: string) {}
}
